const cache = new Map<string, H.map.Icon>()

export function getMapIcon(
  H: any,
  svgString: string,
  width: number,
  height: number,
  anchorX: number,
  anchorY: number,
): H.map.Icon {
  const hit = cache.get(svgString)
  if (hit) return hit
  const icon = new H.map.Icon(svgString, {
    size: { w: width, h: height },
    anchor: { x: anchorX, y: anchorY },
  })
  cache.set(svgString, icon)
  return icon
}

export function clearIconCache(): void {
  cache.clear()
}
